import React from 'react';
import classNames from 'classnames';
import {
  UseFormRegister,
  Controller,
  useFormContext,
  FieldError,
} from 'react-hook-form';
import { get } from 'lodash';
import { FormControl } from './FormControl';
import { Testable } from '../types';

export interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  placeholder?: string;
}

export function TextArea(props: TextAreaProps) {
  return (
    <textarea
      {...props}
      className={classNames(
        'border-gray-400 rounded-md shadow-xs text-sm',
        props.className,
      )}
    />
  );
}

export interface FormTextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  label?: string;
  register?: UseFormRegister<any>;
}

export function FormTextArea({
  label,
  name,
  ...textAreaProps
}: Testable<FormTextAreaProps>) {
  const {
    control,
    formState: { errors, isSubmitting },
  } = useFormContext();
  const error = get(errors, name);

  return (
    <FormControl error={error as FieldError} label={label} name={name}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <TextArea
            {...textAreaProps}
            {...field}
            onChange={(e) => {
              textAreaProps.onChange?.(e);
              field.onChange?.(e);
            }}
            className={classNames(
              isSubmitting && 'bg-gray-100',
              error && 'border-red-600',
              textAreaProps.className,
            )}
          />
        )}
      />
    </FormControl>
  );
}
